import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import {environment} from 'src/environments/environment';
import { DatalayerService } from 'src/services/datalayer.service';
import { AppConstants } from 'src/utils/app.constants';
import { LocalStorage } from 'src/utils/local-storage';

@Component({
  selector: 'app-ad-container',
  templateUrl: './ad-container.component.html',
  styleUrls: ['./ad-container.component.scss']
})
export class AdContainerComponent implements OnInit, OnDestroy {
  @ViewChild('adElement')
  public adElement: ElementRef;

  @Input()
  public adType: string;

  public AD_ROTATION_INTERVAL = 5;

  public invocationCode: string;

  public adJsonData: any[];
  public adIframeHtmlArray: SafeHtml[];

  public currentAdData: any;

  public currentAdIndex = 0;

  public changeAdTimeout: any;

  private isIframeMousedOver: boolean;
  public isOnlyShowingDefaultAds: boolean;

  private currentLanguage: string;
  private lastShownAdCampaign: string;
  private adPostmessageListener: any;

  constructor(public httpClient: HttpClient,
              private sanitizer: DomSanitizer,
              private datalayerService: DatalayerService,
              private renderer: Renderer2,
              private localStorage: LocalStorage,
              private translateService: TranslateService
  ) {
    this.adIframeHtmlArray = [];
    this.currentLanguage = this.translateService.currentLang;

    const userProfile = this.localStorage.getUserProfile();
    this.isOnlyShowingDefaultAds = !!userProfile && !!userProfile.industry 
    && AppConstants.INDUSTRY_CODES_TO_HIDE_ADS
      .indexOf(userProfile.industry) > -1;

    // initialize the listener for postmessages from ads in this component
    this.adPostmessageListener = window.addEventListener('message', (event) => {
      this.receiveAdViewMessage(this, event);
    });
  }
  ngOnDestroy(): void {
    window.removeEventListener('message', (event) => {
      this.receiveAdViewMessage(this, event);
    });
  }

  ngOnInit(): void {
    let thizz = this;
    this.loadAdData(this.isOnlyShowingDefaultAds).pipe(first()).subscribe(res => { 
      this.adJsonData = res.hubAds;
      this.invocationCode = this.adJsonData[0].invocation_code;

      for (let i = 0; i < this.adJsonData.length; i++) {
        const safeAdHtml = this.getInvocationHtml(i);
        this.adIframeHtmlArray.push(safeAdHtml);
      }

      this.setChangeAdTimeout(0);

      if (!this.datalayerService.getResizing()) {
        // the first time the ads are cycled it's not logged
        //this.datalayerService.advertisementViewedEvent(this.adJsonData[this.currentAdIndex]);
      }
      // start listening to click events on the iframe
      this.renderer.listen(window, 'blur', () => this.onWindowBlur());
    });
  }

  changeToNextAd(): void {
    if (this.adJsonData.length > 1) {
      this.currentAdIndex = (this.currentAdIndex + 1) % this.adJsonData.length;
      this.adViewedEvent(this.currentAdIndex);
      this.setChangeAdTimeout(this.currentAdIndex);
    }
  }

  setChangeAdTimeout(index: number): void {
    this.changeAdTimeout = setTimeout(() => {
      this.changeToNextAd();
    }, this.adJsonData[index].changeAdDuration * 1000);
  }

  loadAdData(showDefaultAds: boolean): Observable<any> {
    const headers = new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
    });
    let url = environment.COMMONS_API_ENDPOINT + '/hub/advertisement/' + this.translateService.currentLang + '/';
    if (showDefaultAds) {
      url += 'DEFAULT_';
    } 
    url += this.adType;
    if (environment.mockup) {
        return this.httpClient.get("assets/test/ad.json", { responseType: 'json' }); //Demo
    } else {
        return this.httpClient.post(url, { responseType: 'json', headers: headers });
    }
  }

  getInvocationHtml(index: number): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.adJsonData[index].invocation_code);
  }

  // TODO: Remove this when ad data is sent from revive
  adViewedEvent(index: number): void {
    let isVisible = !!this.adElement && this.adElement.nativeElement.checkVisibility();
    // only track the ad impression if it is visible and the tab is focused on
    if (isVisible && !document.hidden && !this.datalayerService.getResizing()) {
      //this.datalayerService.advertisementViewedEvent(this.adJsonData[index]);
    }
  }

  adClickedEvent(index: number): void {
    this.datalayerService.advertisementClickedEvent(this.currentAdData);
  }

  /* The following functions are for capturing a click on the ads
     We need these since clicking on an iframe normally does not bubble the event 
     to its parent (this component)
  */
  @HostListener('mouseover')
  private onIframeMouseOver() {
    this.isIframeMousedOver = true;
    this.resetFocusOnWindow();
  }

  @HostListener('mouseout')
  private onIframeMouseOut() {
    this.isIframeMousedOver = false;
    this.resetFocusOnWindow();
  }

  private resetFocusOnWindow() {
    setTimeout(() => {
      window.focus();
    }, 100);
  }

  // Event when ad iframe is clicked
  private onWindowBlur() {
    if (this.isIframeMousedOver) {
      this.adClickedEvent(this.currentAdIndex);
      this.resetFocusOnWindow();
    }
  }
  /* end of click events */

  public receiveAdViewMessage(thizz: any, event: any) {
    if (event.data.type === 'adViewEvent' && event.data.htmlContent) {
      //console.log(thizz.adType.toLowerCase() + ' ad data: ' + JSON.stringify(event.data.htmlContent));
      const adType = AppConstants.AD_TYPE_MAPPING[event.data.htmlContent.type];
      if (adType && thizz.adType == adType && thizz.lastShownAdCampaign != event.data.htmlContent.campaign) {
        console.log('SENDING GA DATA for ' + JSON.stringify(event.data.htmlContent));
        thizz.currentAdData = event.data.htmlContent;
        thizz.currentAdData.language = thizz.currentLanguage;
        thizz.datalayerService.advertisementViewedEvent(thizz.currentAdData);
        thizz.lastShownAdCampaign = event.data.htmlContent.campaign;
      }
    }
  }
}
